"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgAlignCenter = function SvgAlignCenter(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("title", null, "center"), React.createElement("g", {
    id: "bfe5ce98-ed3f-4197-9845-64f060ce92c6",
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("rect", {
    width: 1792,
    height: 256
  }), React.createElement("rect", {
    x: 320,
    y: 512,
    width: 1152,
    height: 256
  }), React.createElement("rect", {
    x: 320,
    y: 1536,
    width: 1152,
    height: 256
  }), React.createElement("rect", {
    y: 1024,
    width: 1792,
    height: 256
  })));
};
exports.default = SvgAlignCenter;